import { useRef } from "react";
import styles from "./header.module.css";
import DOMPurify from "dompurify";
import { useEffect } from "react";
import VideoAlert from "../video-alert";

const Header = ({ textData, language, isWeiXin }) => {
  const headerH = useRef(null);
  const headerP = useRef(null);
  const whatchVideoButton = useRef(null);
  const headerHLight = useRef(null);

  useEffect(() => {
    new VideoAlert({
      havePathElement: `.${styles.whatchVideoButton}`,
    });
  });
  return (
    <div className={styles.ctn}>
      <div className={styles.headerText}>
        <svg
          width="553"
          height="75"
          viewBox="0 0 553 75"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={`${styles.headerH} ${isWeiXin ? "show" : ""}`}
          ref={headerH}
        >
          <mask id="smq4-logo-mask">
            <path
              fill="white"
              d="M51.568 12.52C46.904 3.016 36.96 0.287997 27.368 0.287997C16.016 0.375996 3.52 5.568 3.52 18.24C3.52 32.056 15.136 35.4 27.72 36.896C35.904 37.776 41.976 40.152 41.976 45.96C41.976 52.648 35.112 55.2 27.808 55.2C20.328 55.2 13.2 52.208 10.472 45.432L0.792 50.448C5.368 61.712 15.048 65.584 27.632 65.584C41.36 65.584 53.504 59.688 53.504 45.96C53.504 31.264 41.536 27.92 28.688 26.336C21.296 25.456 14.96 23.96 14.96 18.592C14.96 14.016 19.096 10.408 27.72 10.408C34.408 10.408 40.216 13.752 42.328 17.272L51.568 12.52ZM119.692 64.088H131.308V2.48799H114.5L96.9877 44.288L79.4757 2.48799H62.5797V64.088H74.1957V19.296L92.0597 64.088H101.388L119.692 19.384V64.088ZM167.67 1.168C146.374 1.168 135.99 17.448 135.99 33.64C135.99 49.832 146.022 65.408 167.67 65.408C189.318 65.408 199.086 49.48 199.262 33.552C199.438 17.448 188.878 1.168 167.67 1.168ZM167.67 11.728C182.19 11.728 187.998 23.344 187.822 33.728C187.646 43.848 182.19 54.76 167.67 54.76C153.15 54.76 147.694 43.936 147.43 33.816C147.166 23.432 153.15 11.728 167.67 11.728ZM236.764 1.168C215.468 1.168 205.084 17.448 205.084 33.64C205.084 49.832 215.116 65.408 236.764 65.408C258.412 65.408 268.18 49.48 268.356 33.552C268.532 17.448 257.972 1.168 236.764 1.168ZM236.764 11.728C251.284 11.728 257.092 23.344 256.916 33.728C256.74 43.848 251.284 54.76 236.764 54.76C222.244 54.76 216.788 43.936 216.524 33.816C216.26 23.432 222.244 11.728 236.764 11.728ZM289.224 64H300.84V12.96H320.376V2.4H269.688V12.96H289.224V64ZM380.941 64.088V2.48799H369.413V28.448H339.141V2.48799H327.525V64.088H339.141V39.184H369.413V64.088H380.941ZM390.658 40.24H423.13V30.384H390.658V40.24ZM460.971 0.903999C439.323 0.903999 429.203 17.008 429.291 33.112C429.379 49.128 439.059 65.056 460.971 65.056C466.339 65.056 465.107 70.072 489.747 74.12V62.68C489.747 62.68 481.739 62.768 478.043 59.512C487.899 53.704 492.651 39.448 492.563 32.408C492.299 16.568 482.619 0.903999 460.971 0.903999ZM460.971 11.376C475.491 11.376 480.683 22.112 481.123 32.056C481.563 42.616 474.875 54.32 460.971 54.32C447.595 54.32 440.907 43.496 440.731 33.376C440.555 22.992 446.451 11.376 460.971 11.376ZM527.167 2.48799L499.447 40.504V52.296H533.415V64H544.855V52.296H552.071V41.032H544.855V2.48799H527.167ZM512.559 41.032L533.415 12.52V41.032H512.559Z"
            />
          </mask>

          <path d="M51.568 12.52C46.904 3.016 36.96 0.287997 27.368 0.287997C16.016 0.375996 3.52 5.568 3.52 18.24C3.52 32.056 15.136 35.4 27.72 36.896C35.904 37.776 41.976 40.152 41.976 45.96C41.976 52.648 35.112 55.2 27.808 55.2C20.328 55.2 13.2 52.208 10.472 45.432L0.792 50.448C5.368 61.712 15.048 65.584 27.632 65.584C41.36 65.584 53.504 59.688 53.504 45.96C53.504 31.264 41.536 27.92 28.688 26.336C21.296 25.456 14.96 23.96 14.96 18.592C14.96 14.016 19.096 10.408 27.72 10.408C34.408 10.408 40.216 13.752 42.328 17.272L51.568 12.52ZM119.692 64.088H131.308V2.48799H114.5L96.9877 44.288L79.4757 2.48799H62.5797V64.088H74.1957V19.296L92.0597 64.088H101.388L119.692 19.384V64.088ZM167.67 1.168C146.374 1.168 135.99 17.448 135.99 33.64C135.99 49.832 146.022 65.408 167.67 65.408C189.318 65.408 199.086 49.48 199.262 33.552C199.438 17.448 188.878 1.168 167.67 1.168ZM167.67 11.728C182.19 11.728 187.998 23.344 187.822 33.728C187.646 43.848 182.19 54.76 167.67 54.76C153.15 54.76 147.694 43.936 147.43 33.816C147.166 23.432 153.15 11.728 167.67 11.728ZM236.764 1.168C215.468 1.168 205.084 17.448 205.084 33.64C205.084 49.832 215.116 65.408 236.764 65.408C258.412 65.408 268.18 49.48 268.356 33.552C268.532 17.448 257.972 1.168 236.764 1.168ZM236.764 11.728C251.284 11.728 257.092 23.344 256.916 33.728C256.74 43.848 251.284 54.76 236.764 54.76C222.244 54.76 216.788 43.936 216.524 33.816C216.26 23.432 222.244 11.728 236.764 11.728ZM289.224 64H300.84V12.96H320.376V2.4H269.688V12.96H289.224V64ZM380.941 64.088V2.48799H369.413V28.448H339.141V2.48799H327.525V64.088H339.141V39.184H369.413V64.088H380.941ZM390.658 40.24H423.13V30.384H390.658V40.24ZM460.971 0.903999C439.323 0.903999 429.203 17.008 429.291 33.112C429.379 49.128 439.059 65.056 460.971 65.056C466.339 65.056 465.107 70.072 489.747 74.12V62.68C489.747 62.68 481.739 62.768 478.043 59.512C487.899 53.704 492.651 39.448 492.563 32.408C492.299 16.568 482.619 0.903999 460.971 0.903999ZM460.971 11.376C475.491 11.376 480.683 22.112 481.123 32.056C481.563 42.616 474.875 54.32 460.971 54.32C447.595 54.32 440.907 43.496 440.731 33.376C440.555 22.992 446.451 11.376 460.971 11.376ZM527.167 2.48799L499.447 40.504V52.296H533.415V64H544.855V52.296H552.071V41.032H544.855V2.48799H527.167ZM512.559 41.032L533.415 12.52V41.032H512.559Z" />

          <g mask="url(#smq4-logo-mask)">
            <rect
              width="32"
              height="365.39"
              fill="white"
              className={`${styles.headerHLight} ${isWeiXin ? "show" : ""}`}
              ref={headerHLight}
            />
          </g>
        </svg>

        <div
          className={`${styles.headerP} ${isWeiXin ? "show" : ""}`}
          ref={headerP}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text1"]),
          }}
        ></div>
        <div className={styles.videoBox}>
          <video
            autoPlay
            playsInline
            muted
            preload="true"
            className={`${styles.video} ${styles.videoMobile} ${
              isWeiXin ? "show" : ""
            }`}
            onCanPlay={(e) => {
              if (!isWeiXin) {
                e.target.classList.add("active");
                e.target.playbackRate = 1.5;
                headerH.current.classList.add("active");
                headerP.current.classList.add("active");
                whatchVideoButton.current.classList.add("active");
                headerHLight.current.classList.add("active");
              }
            }}
            poster={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-1-poster${
              isWeiXin ? "-wechat" : ""
            }.jpg`}
            src="https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-1.mp4"
          ></video>
        </div>
        <div
          className={`${styles.whatchVideoButton} ${isWeiXin ? "show" : ""}`}
          ref={whatchVideoButton}
          data-video-src={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-tvc-${
            language === "cn" ? "cn" : "en"
          }.mp4`}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 15.1783V4.82167C5 4.03258 5.87115 3.55437 6.53688 3.97801L14.6742 9.15634C15.2917 9.54929 15.2917 10.4507 14.6742 10.8437L6.53688 16.022C5.87115 16.4456 5 15.9674 5 15.1783Z"
              fill="white"
            />
          </svg>
          <div
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(textData["text2"]),
            }}
          ></div>
        </div>
      </div>
      <video
        autoPlay
        playsInline
        muted
        preload="true"
        className={`${styles.video} ${styles.videoPc} ${
          isWeiXin ? "show" : ""
        }`}
        onCanPlay={(e) => {
          if (!isWeiXin) {
            e.target.classList.add("active");
            e.target.playbackRate = 1.5;
            headerH.current.classList.add("active");
            headerP.current.classList.add("active");
            whatchVideoButton.current.classList.add("active");
            headerHLight.current.classList.add("active");
          }
        }}
        poster="https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-1-poster.jpg"
        src="https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-1.mp4"
      ></video>
    </div>
  );
};

export default Header;
